const photoPicker = {
  update: (field, appData) => {
    const value = appData.values[field.name] || [];
    const fieldsArray = appData.screenValidation.fields;
    const { settings } = appData;
    const index = fieldsArray.findIndex(
      fieldItem => fieldItem.fieldName === field.name
    );
    const minPhotos =
      field?.data?.photo_minimum_limit ||
      appData.values?.photo_minimum_limit ||
      0;
    const errorMessage =
      field?.data?.photo_minimum_error ||
      appData.values?.photo_minimum_error ||
      settings.translations.upload_minimum_images_interpolated?.replace(
        "%count%",
        minPhotos
      );

    const isValid = value.length >= minPhotos;
    const fieldObject = {
      fieldName: field.name,
      isValid,
      isRequired: minPhotos > 0,
      errorMessage: !isValid ? errorMessage : null,
      value,
      title: field.title
    };
    if (index > -1) {
      fieldsArray[index] = fieldObject;
    } else {
      fieldsArray.push(fieldObject);
    }
    return fieldObject;
  }
};

export default photoPicker;
